// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dynamic-height[data-v-d9432f48]{height:calc(100vh - 166px)}", "",{"version":3,"sources":["webpack://./resources/js/Tailwind/Components/Settings/Cards.vue"],"names":[],"mappings":"AACA,iCACE,0BAAF","sourcesContent":["\n.dynamic-height {\n  height: calc(100vh - 64px - 102px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
